import { IReportingPeriodApplicantDocumentService } from "../../service/document/ReportingPeriodApplicantDocumentService";

export default class UploadDocumentInteractor {
  private reportingPeriodApplicantDocumentService: IReportingPeriodApplicantDocumentService;

  constructor(reportingPeriodApplicantDocumentService) {
    this.reportingPeriodApplicantDocumentService = reportingPeriodApplicantDocumentService;
  }

  async execute(document: any): Promise<number> {
    return this.reportingPeriodApplicantDocumentService.uploadDocument(
      document
    );
  }
}
